import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import combineStyles from '../../../utils/combineStyles';
import TypographyStyles from '../../../styles/typography';
import ButtonStyles from '../../../styles/button';
import LayoutStyles from '../../../styles/layout';
import SpacingStyles from '../../../styles/helpers/spacing';
import BaseStyles from './Base.styles';

export class Base extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    classes: PropTypes.shape({
      root: PropTypes.string
    }),
    printBOL: PropTypes.func.isRequired,
    printLabels: PropTypes.func.isRequired,
    sendDocs: PropTypes.func.isRequired
  };

  render() {
    const {
      t,
      classes,
      title,
      message,
      printBOL,
      printLabels,
      sendDocs
    } = this.props;
    return (
      <Grid container spacing={0}>
        <Grid item xs={8}>
          <div
            className={classnames(
              classes.baseRoot,
              classes.root,
              classes.gridHeight
            )}
          >
            <div className={classes.info}>
              {this.props.icon && <this.props.icon className={classes.icon} />}
              <div className={classes.details}>
                <p className={classnames(classes.headline5, classes.title)}>
                  {title}
                </p>
                <p className={classnames(classes.headline5, classes.message)}>
                  {message}
                </p>
              </div>
            </div>
            <div className={classes.actions}>
              <Button
                variant={'contained'}
                onClick={printBOL}
                className={classnames(
                  classes.button,
                  classes.basePrintAction,
                  classes.printAction
                )}
                classes={{
                  label: classnames(
                    classes.buttonLabel,
                    classes.basePrintActionLabel,
                    classes.printActionLabel
                  )
                }}
              >
                {t('Print BOL')}
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={printLabels}
                className={classnames(
                  classes.button,
                  classes.basePrintAction,
                  classes.printAction
                )}
                classes={{
                  label: classnames(
                    classes.buttonLabel,
                    classes.basePrintActionLabel,
                    classes.printActionLabel
                  )
                }}
              >
                {t('Print Labels')}
              </Button>
            </div>
          </div>
        </Grid>
        <Grid item xs={4}>
          <div
            className={classnames(
              classes.baseRoot,
              classes.root,
              classes.shareSection,
              classes.gridHeight
            )}
          >
            <div className={classes.info}>
              <div className={classes.details}>
                <p className={classnames(classes.headline5, classes.title)}>
                  {t('Need to share the documents?')}
                </p>
              </div>
            </div>
            <Button
              variant="outlined"
              onClick={sendDocs}
              className={classnames(classes.button, classes.sendAction)}
              classes={{
                label: classnames(classes.buttonLabel, classes.sendActionLabel)
              }}
            >
              {t('Send Documents')}
            </Button>
          </div>
        </Grid>
      </Grid>
    );
  }
}

const baseWithTranslations = withNamespaces()(Base);

export default withStyles(
  combineStyles(
    TypographyStyles,
    LayoutStyles,
    SpacingStyles,
    ButtonStyles,
    BaseStyles
  )
)(baseWithTranslations);
